import { gql } from '@apollo/client';

// kan-111 Settings → AI References tab. Enum fields come back as GraphQL enum
// KEYS ("NEEDS_HUMAN_OUTREACH"), and `statuses` must be sent as keys too.

const AI_REFERENCE_SETTINGS_ROW_FIELDS = `
  entryId
  referenceId
  referenceName
  title
  email
  phoneNumber
  candidate {
    id
    firstName
    lastName
  }
  requestedBy {
    id
    firstName
    lastName
  }
  status
  needsHumanReason
  declineReason
  lastOutreachAt
  outreachReminderCount
  completedAt
  closedAt
  createdAt
  updatedAt
`;

export const MY_AI_REFERENCES = gql`
  query MyAiReferences($filters: AiReferenceSettingsFilter!, $page: Int!, $limit: Int!) {
    myAiReferences(filters: $filters, page: $page, limit: $limit) {
      rows {
        ${AI_REFERENCE_SETTINGS_ROW_FIELDS}
      }
      count
    }
  }
`;

export const ALL_AI_REFERENCES = gql`
  query AllAiReferences($filters: AiReferenceSettingsFilter!, $page: Int!, $limit: Int!) {
    allAiReferences(filters: $filters, page: $page, limit: $limit) {
      rows {
        ${AI_REFERENCE_SETTINGS_ROW_FIELDS}
      }
      count
    }
  }
`;

export const AI_REFERENCE_TRAIL = gql`
  query AiReferenceTrail($referenceEntryId: String!) {
    aiReferenceTrail(referenceEntryId: $referenceEntryId) {
      id
      fromStatus
      toStatus
      reason
      detail
      actorName
      createdAt
    }
  }
`;

// Served by the candidate-section resolver (lane C). Duplicated here under a
// distinct operation name because lane C's answers modal is not exported.
export const SETTINGS_AI_REFERENCE_ANSWERS = gql`
  query SettingsAiReferenceAnswers($referenceEntryId: String!) {
    aiReferenceAnswers(referenceEntryId: $referenceEntryId) {
      referenceEntryId
      status
      transcript
      recordingUrl
      completedAt
      answers {
        label
        prompt
        answer
        sortOrder
        fieldKey
      }
    }
  }
`;

export interface AiReferencePerson {
  id: string;
  firstName: string | null;
  lastName: string | null;
}

export interface AiReferenceSettingsRow {
  entryId: string;
  referenceId: string;
  referenceName: string | null;
  title: string | null;
  email: string | null;
  phoneNumber: string | null;
  candidate: AiReferencePerson | null;
  requestedBy: AiReferencePerson | null;
  status: string;
  needsHumanReason: string | null;
  declineReason: string | null;
  lastOutreachAt: string | null;
  outreachReminderCount: number;
  completedAt: string | null;
  closedAt: string | null;
  createdAt: string;
  updatedAt: string | null;
}

export interface AiReferenceSettingsResult {
  rows: AiReferenceSettingsRow[];
  count: number;
}

export interface AiReferenceSettingsFilter {
  userIds?: string[];
  statuses?: string[];
  dateFrom?: string;
  dateTo?: string;
  search?: string;
}

export interface AiReferenceTrailRow {
  id: string;
  fromStatus: string | null;
  toStatus: string;
  reason: string | null;
  detail: string | null;
  actorName: string | null;
  createdAt: string;
}
